var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{class:_vm.tagColor.className,attrs:{"type":_vm.tagColor.type,"disable-transitions":true,"effect":"plain"}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }